import React, { useEffect, useState, createContext } from 'react';
import Loading from '../shared/Loading';
import EirCustomiseBundleStepper from './EirCustomiseBundleStepper';
import EirCustomiseBundleBroadband from './eir-customise-broadband/EirCustomiseBundleBroadband';
import EirCustomiseBundleTV from './eir-customise-tv/EirCustomiseBundleTV';
import EirCustomiseBundleMobile from './eir-customise-mobile/EirCustomiseBundleMobile';
import EirCustomiseHomePhone from './eir-customise-broadband/EirCustomiseHomePhone';
import EirCustomisePageCartDock from './EirCustomisePageCartDock';
export const CustomiseCheckoutStepContext = createContext(0);
import EirCustomiseBundleIncludes from './EirCustomiseBundleIncludes';
function EirCustomiseCheckout(props) {
    const [custmiseCheckoutActiveStep, setCustmiseCheckoutActiveStep] = useState(0);
    const pageComponents = window.components;
    const [isLoading, setIsLoading] = useState(true);
    const [isBEData, setIsBEData] = useState(false);
    const [isNGB, setIsNGB] = useState(false);
    const [isNBI, setIsNBI] =useState(false);
    //console.log("custmiseCheckoutActiveStep", custmiseCheckoutActiveStep);
    window.addEventListener( "pageshow", function ( event ) {
        var historyTraversal = event.persisted || 
                               ( typeof window.performance != "undefined" && 
                                    window.performance.navigation.type === 2 );
        if ( historyTraversal ) {
          // Handle page restore.
          window.location.reload();
        }
      });
     
    useEffect(() => {
        // $(window).on('popstate', function(event) {

        //     if(localStorage.getItem("ls-eir_clicked_context"))
        //     {
        //     const context_type=localStorage.getItem("ls-eir_clicked_context");

        //      if (context_type === "broadband")
        //      {
        //         window.location.href='/broadband';
                
        //      }
        //      else
        //      {
        //         window.location.href='/tv';  
        //      }
        //     }
     
        //     });

        setIsLoading(false);

        //adding class to body to target css only for this page
        document.querySelector("body").classList.add("customise-bundles-page");
        /************************** TO BE DELETED *************** */
        if (document.querySelector(".mfp-bg") != null) document.querySelector(".mfp-bg").classList.add("d-none");
        if (document.querySelector(".mfp-wrap") != null) document.querySelector(".mfp-wrap").classList.add("d-none");

        let isOpenCMSPage = (location.href.indexOf("/opencms/opencms/") > 0);
        if (!isOpenCMSPage) {
            for (let i = 0; i < pageComponents.length; i++) {
                if (pageComponents[i].type != "eir-header" && pageComponents[i].type != "eir-footer" && pageComponents[i].type != "eir-customise-checkout") {
                    document.getElementById(pageComponents[i].id).classList.add("d-none");
                }
            }
            //show hide respective step banners and other components like rtce, offers

            switch (custmiseCheckoutActiveStep) {
                case (0): {
                    $("#customise-step-0").removeClass("hide-step-element");
                    $("#customise-step-1, #customise-step-2, #customise-step-3").addClass("hide-step-element");
                    break;
                }
                case (1): {
                    $("#customise-step-1").removeClass("hide-step-element");
                    $("#customise-step-0, #customise-step-2, #customise-step-3").addClass("hide-step-element");
                    break;
                }
                case (2): {
                    $("#customise-step-2").removeClass("hide-step-element");
                    $("#customise-step-0, #customise-step-1, #customise-step-3").addClass("hide-step-element");
                    document.querySelector(".add-mobile-sim").click();
                    break;
                }
                case (3): {
                    break;
                }
                default: {
                }
            }



        }

        /***********API to get the backendData --- start  ***************/
        var readCookie = document.cookie.split(";");
        var getOrderId = "";
        for (var i = 0; i < readCookie.length; i++) {
            if (readCookie[i].indexOf("eir_current_order") > 0) {
                getOrderId = readCookie[i].split("=")[1];
            }
        }
        fetch('/store/customise-plan?orderId=' + getOrderId).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error('Something went wrong');
            }
        })
            .then((resp) => {
                localStorage.setItem("eir_be_data", JSON.stringify(resp));
                setIsBEData(true);

                if (JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.broadband.plan.type === "NGB")
                    setIsNGB(true);
                if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.inbi ==true)
                    setIsNBI(true);
                document.querySelector(".customise-checkout-ctr").parentNode.style.cssText = "background:#f4f5f9"
            })
            .catch((error) => {
                console.log(error)
            });
        /***********API to get the backendData --- end  ***************/
    }, []);
    /*Virtual Page view events and Virtual for Customise Bundles Page*/
    const setDataLayer = (title, url) => {
        dataLayer.push({
            'event': 'VirtualPageview',
            'virtualPageURL': url,
            'virtualPageTitle': title
        });
    }
    
    useEffect(() => {
        const virtualPathName=['broadband','tv','mobile'];
        switch (custmiseCheckoutActiveStep) {
            case (0): {
                window.history.pushState({},'',window.location.origin+'/customise-bundles/'+virtualPathName[0]);
                setDataLayer(`Customise-Bundles - Step ${custmiseCheckoutActiveStep} : Broadband | eir.ie`, '/customise-bundles/broadband');
                break;
            }
            case (1): {
                window.history.pushState({},'',window.location.origin+'/customise-bundles/'+(!isNGB ? virtualPathName[1]:virtualPathName[2]));
                (!isNGB) ? setDataLayer(`Customise-Bundles - Step ${custmiseCheckoutActiveStep} : TV | eir.ie`, '/customise-bundles/tv')
                : setDataLayer(`Customise-Bundles - Step ${custmiseCheckoutActiveStep} : Mobile | eir.ie`, '/customise-bundles/mobile');
                break;
            }
            case (2): {
                window.history.pushState({},'',window.location.origin+'/customise-bundles/'+virtualPathName[2]);
                setDataLayer(`Customise-Bundles - Step ${custmiseCheckoutActiveStep} : Mobile | eir.ie`, '/customise-bundles/mobile')
                break;
            }
            default: {
                window.history.pushState({},'',window.location.origin+'/customise-bundles/');
            }
        }
        }, [custmiseCheckoutActiveStep]);
    

    return (
        <div>
            {isBEData &&
                <div>
                    <EirCustomiseBundleIncludes />
                    {isLoading &&
                        <Loading className="m-5" />
                    }
                    <div className="container customise-checkout-ctr pb-6">
                        <CustomiseCheckoutStepContext.Provider value={custmiseCheckoutActiveStep}>
                            {/* <!-- Main Content --> */}
                            <div>
                                <div role="main">
                                    <EirCustomiseBundleStepper setCustmiseCheckoutActiveStep={setCustmiseCheckoutActiveStep} />
                                    {/* <!-- start application page  --> */}
                                    <div className="application-page ap-fade-in">
                                        <div className="wrapper__margin">
                                            <div className="application-page__container">
                                                <div className="application-page__main">
                                                    {/* <!-- start application page modules --> */}
                                                    {/* <div className="row">
                                                        <div className="column large-12 small-12 p-0">
                                                            <div className="alert fill-blue hide-elem">
                                                                <div className="row">
                                                                    <div className="alert__text-column">
                                                                        <p className="alert__header">We Need Your Attention!</p>
                                                                        <p className="alert__subtext">You may have made some changes to your original bundle. If you would like to revert click the button.</p>
                                                                    </div>
                                                                    <div className="alert__button-column">
                                                                        <a href="" className="button button--small button--secondary fill-white text-black--light gtm-normal-cta">Update Cart</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <div className="row">
                                                        <div className="column large-12 small-12 p-0">
                                                            {/* <section className="bundle-summary"> */}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="column large-12 small-12 p-0">
                                                            {/* <div>OFFERS /RTCE TO BE PLACED HERE</div> */}
                                                            <div className="ap-config__accordion">

                                                                <div id="customise-step-0" className={(custmiseCheckoutActiveStep === 0) ? "" : "hide-step-element"}>
                                                                    <EirCustomiseBundleBroadband setCustmiseCheckoutActiveStep={setCustmiseCheckoutActiveStep} />
                                                                </div>
                                                                
                                                                {/* To hide TV stepper when customer type is NGB */}
                                                                {!isNGB && !isNBI &&
                                                                    <div id="customise-step-1" className={(custmiseCheckoutActiveStep === 1) ? "tv-min-height" : "hide-step-element"}>
                                                                        <EirCustomiseBundleTV setCustmiseCheckoutActiveStep={setCustmiseCheckoutActiveStep} />
                                                                    </div>
                                                                }
                                                                {!isNGB && !isNBI &&
                                                                    <div id="customise-step-2" className={(custmiseCheckoutActiveStep === 2) ? "" : "hide-step-element"}>
                                                                        <EirCustomiseBundleMobile setCustmiseCheckoutActiveStep={setCustmiseCheckoutActiveStep} />
                                                                    </div>
                                                                }
                                                                {isNGB && !isNBI &&
                                                                    <div id="customise-step-2" className={(custmiseCheckoutActiveStep === 1) ? "" : "hide-step-element"}>
                                                                        <EirCustomiseBundleMobile setCustmiseCheckoutActiveStep={setCustmiseCheckoutActiveStep} />
                                                                    </div>
                                                                }
                                                                {custmiseCheckoutActiveStep === 3 &&
                                                                    <div id="customise-step-3" className={'checkout-stepper ' + ((custmiseCheckoutActiveStep === 3) ? "" : "hide-step-element")}>
                                                                        <EirCustomiseHomePhone setCustmiseCheckoutActiveStep={setCustmiseCheckoutActiveStep} />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <!-- end application page modules --> */}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- end application page --> */}


                                </div>
                                {/* <!-- end main content --> */}

                            </div>


                        </CustomiseCheckoutStepContext.Provider>
                    </div>
                    <div className={"cutomisepage-bottom-fixed-bar"}>

                        <EirCustomisePageCartDock setCustmiseCheckoutActiveStep={setCustmiseCheckoutActiveStep} custmiseCheckoutActiveStep={custmiseCheckoutActiveStep} />

                    </div>
                </div>
            }
        </div >

    );
}
export default EirCustomiseCheckout;
